import script from "./DhTableColumn.vue?vue&type=script&lang=ts"
export * from "./DhTableColumn.vue?vue&type=script&lang=ts"

export default script